import React from 'react'

const PlusIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props?.fill || "none"} viewBox="0 0 24 24" {...props}>
    <path fill={props?.fill || "#0D1536"} fillOpacity="1" d="M12 5c-.552 0-1 .448-1 1v5H6c-.552 0-1 .448-1 1s.448 1 1 1h5v5c0 .552.448 1 1 1s1-.448 1-1v-5h5c.552 0 1-.448 1-1s-.448-1-1-1h-5V6c0-.552-.448-1-1-1z"/>
  </svg>
)

export default PlusIcon
